<!-- 机构用户创建项目 -->
<template>
    <div class="index-page">
        <div class="steps-content">
            <template v-for="(step, index) in steps">
                <div
                    :class="[
                        'step-item',
                        activeStepIndex === index ? 'active' : '',
                    ]"
                    :key="index"
                >
                    <div class="step-name">{{ index + 1 }}. {{ step }}</div>
                    <div class="step-arrow" v-if="index < steps.length - 1">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </template>
        </div>
        <div class="upload-content" v-show="activeStepIndex === 0">
            <create-upload
                ref="createUploadDom"
                @action="executeAction"
            ></create-upload>
            <div class="next-btn">
                <el-button
                    type="primary"
                    round
                    :loading="nextBtnLoading"
                    @click="nextBtnEvent"
                    v-if="Object.keys(fileData).length > 0"
                    >{{
                        $t("project.project_create_page_btn_text_1")
                    }}</el-button
                >
            </div>
        </div>
        <div class="setting-content" v-show="activeStepIndex === 1">
            <el-card
                class="none-boder radius-12 margin-t-20"
                :body-style="{ padding: '30px' }"
            >
                <div class="project-info margin-b-20">
                    <div class="flex margin-b-10">
                        <div class="flex-1 margin-r-10">
                            <el-card
                                shadow="never"
                                class="none-boder radius-12"
                                :body-style="{
                                    backgroundColor: '#F8F8F8',
                                    padding: '15px 20px',
                                }"
                            >
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_14"
                                        )
                                    }}
                                    <el-tooltip
                                        :content="
                                            $t(
                                                'project.project_create_page_tips_9'
                                            )
                                        "
                                        placement="top"
                                    >
                                        <router-link
                                            to="/project/template"
                                            target="_blank"
                                            class="margin-l-5"
                                        >
                                            <svg-icon name="ib-link"></svg-icon>
                                        </router-link>
                                    </el-tooltip>
                                </div>
                                <div>
                                    <el-select
                                        v-model="projectTemplate"
                                        @change="projectTemplateChangeEvent"
                                        :placeholder="
                                            $t(
                                                'project.project_create_page_form_placeholder_14'
                                            )
                                        "
                                        size="small"
                                        filterable
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in projectTemplateOptions"
                                            :key="item.templateId"
                                            :label="item.templateName"
                                            :value="item.templateId"
                                        ></el-option>
                                    </el-select>
                                </div>
                            </el-card>
                        </div>
                        <div class="flex-1">
                            <el-card
                                shadow="never"
                                class="none-boder radius-12"
                                :body-style="{
                                    backgroundColor: '#F8F8F8',
                                    padding: '15px 20px',
                                }"
                            >
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_1"
                                        )
                                    }}
                                </div>
                                <div>
                                    <el-input
                                        ref="defaultProjectName"
                                        size="small"
                                        v-model="defaultProjectName"
                                        :placeholder="
                                            $t(
                                                'project.project_create_page_form_placeholder_1'
                                            )
                                        "
                                        maxlength="200"
                                        autofocus="true"
                                    ></el-input>
                                </div>
                            </el-card>
                        </div>
                    </div>
                    <div class="flex margin-b-10">
                        <div class="flex-1">
                            <el-card
                                shadow="never"
                                class="none-boder radius-12"
                                :body-style="{
                                    backgroundColor: '#F8F8F8',
                                    padding: '15px 20px',
                                }"
                            >
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_2"
                                        )
                                    }}
                                </div>
                                <div>
                                    <el-select
                                        v-model="translationProcess"
                                        size="small"
                                        :placeholder="
                                            $t(
                                                'project.project_create_page_form_placeholder_2'
                                            )
                                        "
                                    >
                                        <template
                                            v-for="item in workflowOptions"
                                        >
                                            <el-option
                                                :label="item.description"
                                                :value="item.name"
                                                :key="item.name"
                                            ></el-option>
                                        </template>
                                    </el-select>
                                </div>
                            </el-card>
                        </div>
                        <div class="flex-1 margin-l-10">
                            <el-card
                                shadow="never"
                                class="none-boder radius-12"
                                :body-style="{
                                    backgroundColor: '#F8F8F8',
                                    padding: '15px 20px',
                                }"
                            >
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_3"
                                        )
                                    }}
                                </div>
                                <div>
                                    <el-select
                                        v-model="teamId"
                                        size="small"
                                        :placeholder="
                                            $t(
                                                'project.project_create_page_form_placeholder_3'
                                            )
                                        "
                                        @change="teamChangeEvent"
                                    >
                                        <template v-for="item in teamOptions">
                                            <el-option
                                                :label="item.text"
                                                :value="item.value"
                                                :key="item.value"
                                            ></el-option>
                                        </template>
                                    </el-select>
                                </div>
                            </el-card>
                        </div>
                        <div class="flex-1 margin-l-10">
                            <el-card
                                shadow="never"
                                class="none-boder radius-12"
                                :body-style="{
                                    backgroundColor: '#F8F8F8',
                                    padding: '15px 20px',
                                }"
                            >
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_4"
                                        )
                                    }}
                                </div>
                                <div>
                                    <el-date-picker
                                        size="small"
                                        v-model="deadline"
                                        type="datetime"
                                        :placeholder="
                                            $t(
                                                'project.project_create_page_form_placeholder_4'
                                            )
                                        "
                                    >
                                    </el-date-picker>
                                </div>
                            </el-card>
                        </div>
                    </div>
                    <div class="language-setting-content">
                        <div class="flex padding-x-20 padding-t-10">
                            <div class="flex-1">
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_5"
                                        )
                                    }}
                                </div>
                                <div>
                                    <el-tooltip
                                        content="输入关键词可搜索"
                                        placement="top"
                                    >
                                        <el-select
                                            v-model="form.originValue"
                                            filterable
                                            size="small"
                                            :placeholder="
                                                $t(
                                                    'project.project_create_page_form_placeholder_5'
                                                )
                                            "
                                            @change="originValueChangeEvent"
                                            popper-class="language-select-popper-class"
                                            style="width: 100%"
                                        >
                                            <template
                                                v-for="(
                                                    value, key
                                                ) in LANGUAGE_DICT"
                                            >
                                                <el-option
                                                    :label="value.name"
                                                    :value="value.key"
                                                    :key="key"
                                                ></el-option>
                                            </template>
                                        </el-select>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="target-select flex-1 margin-l-20">
                                <div class="margin-b-10 fonts-12">
                                    {{
                                        $t(
                                            "project.project_create_page_form_label_6"
                                        )
                                    }}
                                </div>
                                <div>
                                    <el-tooltip
                                        content="输入关键词可搜索"
                                        placement="top"
                                    >
                                        <el-select
                                            v-model="form.targetValue"
                                            multiple
                                            collapse-tags
                                            filterable
                                            size="small"
                                            :placeholder="
                                                $t(
                                                    'project.project_create_page_form_placeholder_6'
                                                )
                                            "
                                            @change="targetValueChangeEvent"
                                            popper-class="language-select-popper-class"
                                            style="width: 100%"
                                        >
                                            <template
                                                v-for="(
                                                    value, key
                                                ) in LANGUAGE_DICT"
                                            >
                                                <el-option
                                                    :label="value.name"
                                                    :value="value.key"
                                                    :key="key"
                                                    v-if="
                                                        value.key !==
                                                        form.originValue
                                                    "
                                                ></el-option>
                                            </template>
                                        </el-select>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="language-list">
                            <template
                                v-for="(item, index) in languageEngineList"
                            >
                                <div class="item" :key="index">
                                    <div class="flex-1 fonts-15">
                                        <language-direction
                                            :source="form.originValue"
                                            :target="item.target"
                                        ></language-direction>
                                    </div>
                                    <el-tooltip
                                        :content="
                                            $t(
                                                'project.project_create_page_tips_1'
                                            )
                                        "
                                        placement="top"
                                    >
                                        <div
                                            class="compare-btn"
                                            @click="
                                                compareEngine({
                                                    source: form.originValue,
                                                    ...item,
                                                })
                                            "
                                        >
                                            <img
                                                src="../../../static/images/engine/translation-score-icon.png"
                                                alt="compare icon"
                                            />
                                            <!-- <svg-icon name="ib-robot"></svg-icon> -->
                                        </div>
                                    </el-tooltip>
                                    <div class="engine-select">
                                        <el-select
                                            v-model="item.engine"
                                            value-key="key"
                                            size="small"
                                            :placeholder="
                                                $t(
                                                    'project.project_create_page_form_placeholder_7'
                                                )
                                            "
                                        >
                                            <template
                                                slot="prefix"
                                                v-if="
                                                    item.engine &&
                                                    item.engine.icon
                                                "
                                            >
                                                <svg-icon
                                                    :name="`ie-${item.engine.icon}`"
                                                    className="fonts-20"
                                                ></svg-icon>
                                            </template>
                                            <el-option-group>
                                                <el-option
                                                    :label="
                                                        $t(
                                                            'project.project_create_page_select_option_label_1'
                                                        )
                                                    "
                                                    value="NONE"
                                                    key="NONE"
                                                ></el-option>
                                            </el-option-group>
                                            <template
                                                v-for="domain in item.options"
                                            >
                                                <el-option-group
                                                    :label="domain.name"
                                                    :key="domain.key"
                                                    v-if="
                                                        domain.engines.length >
                                                        0
                                                    "
                                                >
                                                    <el-option
                                                        v-for="engine in domain.engines"
                                                        :value="engine"
                                                        :key="engine.key"
                                                        :label="engine.name"
                                                    >
                                                        <div
                                                            class="flex flex-align-center"
                                                        >
                                                            <svg-icon
                                                                :name="`ie-${engine.icon}`"
                                                                className="margin-r-10 fonts-20"
                                                            ></svg-icon>
                                                            <span>{{
                                                                engine.name
                                                            }}</span>
                                                        </div>
                                                    </el-option>
                                                </el-option-group>
                                            </template>
                                        </el-select>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="tab-list">
                        <template v-for="(item, index) in tabData.tabs">
                            <div
                                :class="[
                                    'item',
                                    tabData.tabActiveIndex === index
                                        ? 'active'
                                        : '',
                                ]"
                                :key="index"
                                @click="settingTabEvent(item, index)"
                            >
                                {{ item }}
                            </div>
                        </template>
                    </div>
                    <div v-show="tabData.tabActiveIndex === 0">
                        <div class="fonts-14 margin-t-15">
                            {{ $t("project.project_create_page_tips_2") }}
                        </div>
                        <div class="flex flex-justify-between margin-t-15">
                            <div class="flex flex-align-center">
                                <div
                                    class="flex flex-align-center fonts-14 margin-r-10"
                                >
                                    <div>
                                        {{
                                            LANGUAGE_DICT[form.originValue].name
                                        }}
                                    </div>
                                    <svg-icon
                                        name="ib-arrow-right"
                                        class="margin-x-5"
                                    ></svg-icon>
                                    <el-select
                                        v-model="memLangValue"
                                        @change="memLangSelectChange"
                                        size="mini"
                                        style="width: 140px"
                                    >
                                        <template
                                            v-for="(
                                                item, index
                                            ) in form.targetValue"
                                        >
                                            <el-option
                                                :key="index"
                                                :value="item"
                                                :label="
                                                    LANGUAGE_DICT[item].name
                                                "
                                            ></el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <el-button
                                    size="mini"
                                    plain
                                    round
                                    @click="gotoMemoryPage"
                                    icon="el-icon-plus"
                                    >{{
                                        $t(
                                            "project.project_create_page_btn_text_2"
                                        )
                                    }}</el-button
                                >
                                <el-button
                                    size="mini"
                                    plain
                                    round
                                    @click="
                                        initTargetLangMemoryList(memLangValue)
                                    "
                                    icon="el-icon-refresh-right"
                                    >{{
                                        $t(
                                            "project.project_create_page_btn_text_3"
                                        )
                                    }}</el-button
                                >
                            </div>
                            <div class="fonts-13 mem-matching-setting">
                                <span class="margin-r-10"
                                    ><span
                                        class="color-error fonts-16"
                                        style="margin-right: 1px"
                                        >*</span
                                    >{{
                                        $t(
                                            "project.project_create_page_form_label_8"
                                        )
                                    }}</span
                                >
                                <el-select
                                    :placeholder="
                                        $t(
                                            'project.project_create_page_form_placeholder_8'
                                        )
                                    "
                                    v-model="memMatchingRate"
                                    size="mini"
                                    style="width: 78px"
                                >
                                    <template
                                        v-for="item in memMatchingOptions"
                                    >
                                        <el-option
                                            :label="item"
                                            :value="item"
                                            :key="item"
                                        ></el-option>
                                    </template>
                                </el-select>
                            </div>
                        </div>
                        <el-table
                            ref="memoryTable"
                            :data="tabData.memoryList"
                            max-height="480"
                            style="width: 100%"
                            @selection-change="handleMemoryTableSelectionChange"
                            @sort-change="handleMemorySortChange"
                        >
                            <el-table-column
                                type="selection"
                                width="42"
                            ></el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_memoryTable_column_label_1'
                                    )
                                "
                                width="60"
                            >
                                <template slot-scope="scope">
                                    <el-switch
                                        :value="
                                            writeableLangMemId ===
                                            scope.row.memId
                                        "
                                        active-color="#1AC49C"
                                        @change="
                                            (val) =>
                                                handleMemoryWriteChange(
                                                    val,
                                                    scope.row
                                                )
                                        "
                                    ></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_memoryTable_column_label_2'
                                    )
                                "
                                show-overflow-tooltip
                                sortable="custom"
                                column-key="name"
                            >
                                <template slot-scope="scope">
                                    <router-link
                                        :to="{
                                            path: '/asset/memory/detail',
                                            query: { id: scope.row.memId },
                                        }"
                                        target="_blank"
                                        >{{ scope.row.name }}</router-link
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_memoryTable_column_label_3'
                                    )
                                "
                            >
                                <template slot-scope="scope">
                                    <language-direction
                                        :source="scope.row.sourceLang"
                                        :target="scope.row.targetLang"
                                        type="half"
                                    ></language-direction>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_memoryTable_column_label_4'
                                    )
                                "
                                prop="nums"
                                width="90"
                                sortable="custom"
                                column-key="nums"
                            >
                                <template slot-scope="scope">
                                    <span
                                        >{{ scope.row.nums }}
                                        {{
                                            $t(
                                                "project.project_create_page_memoryTable_column_4_label_1"
                                            )
                                        }}</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_memoryTable_column_label_5'
                                    )
                                "
                                width="110"
                            >
                                <template slot-scope="scope">
                                    <el-input-number
                                        size="mini"
                                        :disabled="
                                            getMemoryPenaltyPointsInputStatus(
                                                scope.row
                                            )
                                        "
                                        v-model="
                                            scope.row.setting[0].penaltyPoints
                                        "
                                        @change="
                                            (val) =>
                                                handleMemoryPenaltyPointsChange(
                                                    val,
                                                    scope.row
                                                )
                                        "
                                        controls-position="right"
                                        :step="1"
                                        :precision="0"
                                        :min="0"
                                        :max="15"
                                        style="width: 90px"
                                    ></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_memoryTable_column_label_6'
                                    )
                                "
                                prop="createTime"
                                width="160"
                                sortable="custom"
                                column-key="createAt"
                            ></el-table-column>
                        </el-table>
                    </div>
                    <div v-show="tabData.tabActiveIndex === 1">
                        <el-alert type="info" effect="dark" :closable="false">
                            <template slot="title">
                                <div
                                    class="flex flex-align-center"
                                    v-if="
                                        ['personal', 'pro-limited'].indexOf(
                                            userInfo.accountType
                                        ) > -1
                                    "
                                >
                                    <svg-icon
                                        name="icon-free"
                                        style="font-size: 22px"
                                        class="margin-r-10"
                                    ></svg-icon
                                    >{{
                                        $t(
                                            "project.project_create_page_tips_3"
                                        )
                                    }}<a href="/account/vip" target="_blank">{{
                                        $t("project.project_create_page_tips_4")
                                    }}</a>
                                </div>
                                <div class="flex flex-align-center" v-else>
                                    <svg-icon
                                        name="ic-pro"
                                        style="font-size: 22px"
                                        class="margin-r-10"
                                    ></svg-icon
                                    >{{ userInfo.accountTypeDesc }}
                                    {{
                                        $t("project.project_create_page_tips_5")
                                    }}
                                </div>
                            </template>
                        </el-alert>
                        <div class="fonts-14 margin-t-15">
                            {{ $t("project.project_create_page_tips_6") }}
                        </div>
                        <div class="flex flex-align-center margin-t-15">
                            <div
                                class="flex flex-align-center fonts-14 margin-r-10"
                            >
                                <div>
                                    {{ LANGUAGE_DICT[form.originValue].name }}
                                </div>
                                <svg-icon
                                    name="ib-arrow-right"
                                    class="margin-x-5"
                                ></svg-icon>
                                <el-select
                                    v-model="termLangValue"
                                    @change="termLangSelectChange"
                                    size="mini"
                                    style="width: 140px"
                                >
                                    <template
                                        v-for="(
                                            item, index
                                        ) in form.targetValue"
                                    >
                                        <el-option
                                            :key="index"
                                            :value="item"
                                            :label="LANGUAGE_DICT[item].name"
                                        ></el-option>
                                    </template>
                                </el-select>
                            </div>
                            <el-button
                                size="mini"
                                plain
                                round
                                @click="gotoTermPage"
                                icon="el-icon-plus"
                                >{{
                                    $t("project.project_create_page_btn_text_4")
                                }}</el-button
                            >
                            <el-button
                                size="mini"
                                plain
                                round
                                @click="initTargetLangTermList(termLangValue)"
                                icon="el-icon-refresh-right"
                                >{{
                                    $t("project.project_create_page_btn_text_5")
                                }}</el-button
                            >
                        </div>
                        <el-table
                            ref="termsTable"
                            :data="tabData.termsList"
                            max-height="480"
                            style="width: 100%"
                            @selection-change="handleTermsTableSelectionChange"
                            @sort-change="handleTermsSortChange"
                        >
                            <el-table-column
                                type="selection"
                                width="42"
                            ></el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_termsTable_column_label_1'
                                    )
                                "
                                width="60"
                            >
                                <template slot-scope="scope">
                                    <el-switch
                                        :value="
                                            writeableTermId === scope.row.termId
                                        "
                                        active-color="#1AC49C"
                                        @change="
                                            (val) =>
                                                handleTermWriteChange(
                                                    val,
                                                    scope.row
                                                )
                                        "
                                    ></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_termsTable_column_label_2'
                                    )
                                "
                                show-overflow-tooltip
                                sortable="custom"
                                column-key="name"
                            >
                                <template slot-scope="scope">
                                    <router-link
                                        :to="{
                                            path: '/asset/term/detail',
                                            query: { id: scope.row.termId },
                                        }"
                                        target="_blank"
                                        >{{ scope.row.name }}</router-link
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_termsTable_column_label_3'
                                    )
                                "
                            >
                                <template slot-scope="scope">
                                    <language-direction
                                        :source="scope.row.sourceLang"
                                        :target="scope.row.targetLang"
                                        type="half"
                                    ></language-direction>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_termsTable_column_label_4'
                                    )
                                "
                                prop="nums"
                                width="90"
                                sortable="custom"
                                column-key="nums"
                            >
                                <template slot-scope="scope">
                                    <span
                                        >{{ scope.row.nums }}
                                        {{
                                            $t(
                                                "project.project_create_page_termsTable_column_4_label_1"
                                            )
                                        }}</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_termsTable_column_label_6'
                                    )
                                "
                                prop="createTime"
                                width="160"
                                sortable="custom"
                                column-key="createAt"
                            ></el-table-column>
                        </el-table>
                    </div>
                    <div
                        class="padding-t-10"
                        v-show="tabData.tabActiveIndex === 2"
                    >
                        <template v-for="(item, index) in docSettingOpts">
                            <div
                                class="doc-config-card"
                                shadow="never"
                                :key="index"
                            >
                                <div class="flex flex-align-center">
                                    <el-tooltip
                                        :content="item.name"
                                        placement="top"
                                    >
                                        <div
                                            class="doc-icon file-word flex flex-justify-center flex-align-center"
                                        >
                                            <svg-icon
                                                :name="'ic-' + item.icon"
                                                className="fonts-17"
                                            ></svg-icon>
                                        </div>
                                    </el-tooltip>
                                    <div
                                        class="check-all margin-l-30"
                                        style="width: 87px"
                                    >
                                        <el-checkbox
                                            v-model="item.checkAll"
                                            :indeterminate="item.indeterminate"
                                            @change="
                                                (val) =>
                                                    docSettingCheckAllChange(
                                                        val,
                                                        index
                                                    )
                                            "
                                            >{{
                                                $t(
                                                    "project.project_create_page_form_label_9"
                                                )
                                            }}</el-checkbox
                                        >
                                    </div>
                                    <div class="flex-1">
                                        <div class="options-list">
                                            <template
                                                v-for="(
                                                    opt, oIndex
                                                ) in item.options"
                                            >
                                                <div
                                                    class="margin-r-30"
                                                    :key="oIndex"
                                                >
                                                    <el-checkbox
                                                        v-model="opt.value"
                                                        :label="opt.value"
                                                        @change="
                                                            (val) =>
                                                                docSettingCheckChange(
                                                                    val,
                                                                    index,
                                                                    oIndex
                                                                )
                                                        "
                                                        >{{
                                                            opt.label
                                                        }}</el-checkbox
                                                    >
                                                    <template
                                                        v-if="
                                                            opt.key ===
                                                            'multiColumn'
                                                        "
                                                    >
                                                        <el-tooltip
                                                            :content="
                                                                $t(
                                                                    'project.project_create_page_form_label_15'
                                                                )
                                                            "
                                                            placement="top"
                                                        >
                                                            <el-button
                                                                @click="
                                                                    showMultiColumnExcelParseDialogEvent
                                                                "
                                                                type="text"
                                                                :disabled="
                                                                    !opt.value
                                                                "
                                                                class="margin-l-2 padding-0"
                                                            >
                                                                <svg-icon
                                                                    name="ib-setting"
                                                                    class="fonts-18"
                                                                ></svg-icon>
                                                            </el-button>
                                                        </el-tooltip>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div
                        class="padding-t-10"
                        v-show="tabData.tabActiveIndex === 3"
                    >
                        <div class="qa-setting margin-t-10">
                            <div class="block-title">
                                {{
                                    $t(
                                        "project.project_create_page_form_label_10"
                                    )
                                }}
                            </div>
                            <div class="option-list">
                                <template
                                    v-for="(item, index) in qaSetting.basicList"
                                >
                                    <div class="item" :key="index">
                                        <el-checkbox
                                            v-model="item.selected"
                                            :disabled="!item.enabled"
                                            :label="item.description"
                                        ></el-checkbox>
                                    </div>
                                </template>
                            </div>
                            <div class="block-title">
                                {{
                                    $t(
                                        "project.project_create_page_form_label_11"
                                    )
                                }}
                            </div>
                            <div class="option-list">
                                <template
                                    v-for="(item, index) in qaSetting.aiList"
                                >
                                    <div class="item" :key="index">
                                        <el-checkbox
                                            v-model="item.selected"
                                            :disabled="!item.enabled"
                                            :label="item.description"
                                        ></el-checkbox>
                                    </div>
                                </template>
                            </div>
                            <div class="block-title">
                                {{
                                    $t(
                                        "project.project_create_page_form_label_12"
                                    )
                                }}
                            </div>
                            <div class="option-list">
                                <div class="item">
                                    <el-checkbox
                                        v-model="qaSetting.checkQa"
                                        :label="
                                            $t(
                                                'project.project_create_page_form_label_13'
                                            )
                                        "
                                    ></el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="padding-t-15"
                        v-show="tabData.tabActiveIndex === 4"
                    >
                        <el-image
                            style="display: none"
                            ref="backupEngineExample"
                            src="https://nextcat.oss-accelerate.aliyuncs.com/fe_projects/backup-engine-example.png?OSSAccessKeyId=LTAI5tLMrodVLgCBBYxPFDRf&Expires=101677055427&Signature=fKZxWhwx5HfiOfUw6lmMV%2FkU8KA%3D"
                            :preview-src-list="[
                                'https://nextcat.oss-accelerate.aliyuncs.com/fe_projects/backup-engine-example.png?OSSAccessKeyId=LTAI5tLMrodVLgCBBYxPFDRf&Expires=101677055427&Signature=fKZxWhwx5HfiOfUw6lmMV%2FkU8KA%3D',
                            ]"
                        ></el-image>
                        <div class="margin-b-15 fonts-12 color-666666">
                            {{ $t("project.project_create_page_tips_7")
                            }}<a
                                href="javascript:;"
                                class="margin-l-10"
                                @click="
                                    $refs.backupEngineExample.clickHandler()
                                "
                                >{{
                                    $t("project.project_create_page_tips_8")
                                }}</a
                            >
                        </div>
                        <div class="language-list" style="border: none">
                            <template
                                v-for="(item, index) in languageEngineList"
                            >
                                <div class="item" :key="index">
                                    <div class="flex-1 fonts-15">
                                        <language-direction
                                            :source="form.originValue"
                                            :target="item.target"
                                            type="half"
                                        ></language-direction>
                                    </div>
                                    <div class="engine-select">
                                        <el-select
                                            v-model="item.referenceEngine"
                                            value-key="key"
                                            size="small"
                                            :placeholder="
                                                $t(
                                                    'project.project_create_page_form_placeholder_12'
                                                )
                                            "
                                            @focus="
                                                initReferenceEngineList(item)
                                            "
                                            style="width: 100%"
                                        >
                                            <template
                                                slot="prefix"
                                                v-if="
                                                    item.referenceEngine &&
                                                    item.referenceEngine.icon
                                                "
                                            >
                                                <svg-icon
                                                    :name="`ie-${item.referenceEngine.icon}`"
                                                    className="fonts-20"
                                                ></svg-icon>
                                            </template>
                                            <template
                                                v-for="domain in item.referenceOptions"
                                            >
                                                <el-option
                                                    v-for="engine in domain.engines"
                                                    :value="engine"
                                                    :key="engine.key"
                                                    :label="engine.name"
                                                >
                                                    <div
                                                        class="flex flex-align-center"
                                                    >
                                                        <svg-icon
                                                            :name="`ie-${engine.icon}`"
                                                            className="margin-r-10 fonts-20"
                                                        ></svg-icon>
                                                        <span>{{
                                                            engine.name
                                                        }}</span>
                                                    </div>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div
                        class="padding-t-15"
                        v-show="tabData.tabActiveIndex === 5"
                    >
                        <div class="remark-input">
                            <el-input
                                v-model="remark"
                                type="textarea"
                                maxlength="500"
                                show-word-limit
                                :rows="3"
                                resize="none"
                                :placeholder="
                                    $t(
                                        'project.project_create_page_form_placeholder_13'
                                    )
                                "
                            ></el-input>
                        </div>
                        <div class="padding-y-15 border-b">
                            <el-button
                                plain
                                round
                                size="mini"
                                icon="el-icon-plus"
                                @click="remarkFileUpload.show = true"
                                >{{
                                    $t("project.project_create_page_btn_text_6")
                                }}</el-button
                            >
                        </div>
                        <el-table :data="remarkFileList" style="width: 100%">
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_remarkFileTable_column_label_1'
                                    )
                                "
                                type="index"
                            ></el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_remarkFileTable_column_label_2'
                                    )
                                "
                                prop="fileName"
                            ></el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_remarkFileTable_column_label_3'
                                    )
                                "
                                prop="time"
                            ></el-table-column>
                            <el-table-column
                                :label="
                                    $t(
                                        'project.project_create_page_remarkFileTable_column_label_4'
                                    )
                                "
                                width="100px"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="mini"
                                        @click="deleteRemarkFile(scope)"
                                    >
                                        <svg-icon
                                            name="ib-trash-o"
                                            className="fonts-16"
                                        ></svg-icon>
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-dialog
                            :title="
                                $t('project.project_create_page_dialog_1_title')
                            "
                            :visible.sync="remarkFileUpload.show"
                            destroy-on-close
                            :width="'520px'"
                            top="20px"
                        >
                            <div class="fonts-12 margin-b-15 text-center">
                                {{
                                    $t(
                                        "project.project_create_page_dialog_1_tips_1"
                                    )
                                }}
                                <span class="color-link">{{
                                    $t(
                                        "project.project_create_page_dialog_1_tips_2"
                                    )
                                }}</span>
                                {{
                                    $t(
                                        "project.project_create_page_dialog_1_tips_3"
                                    )
                                }}
                            </div>
                            <!-- <div class="fonts-12 margin-b-15 text-center">{{remarkFileUpload.supportFiles}}</div> -->
                            <upload-oss
                                ref="remarkFileUploadDom"
                                :multiple="true"
                                :limit="10 - remarkFileList.length"
                                :size="50"
                                :accept="remarkFileUpload.accept"
                                :params="{}"
                                :type="`STYLE_GUIDE`"
                            ></upload-oss>
                            <div slot="footer" class="text-center">
                                <el-button
                                    round
                                    plain
                                    size="small"
                                    @click="remarkFileUpload.show = false"
                                    >{{
                                        $t(
                                            "project.project_create_page_dialog_1_btn_1"
                                        )
                                    }}</el-button
                                >
                                <el-button
                                    round
                                    type="primary"
                                    size="small"
                                    :loading="remarkFileUpload.loading"
                                    @click="submitUploadRemarkFile"
                                    >{{
                                        $t(
                                            "project.project_create_page_dialog_1_btn_2"
                                        )
                                    }}</el-button
                                >
                            </div>
                        </el-dialog>
                    </div>
                    <div
                        class="padding-t-15"
                        v-show="tabData.tabActiveIndex === 6"
                    >
                        <div class="qa-setting margin-t-10">
                            <div class="block-title">
                                {{ $t("project.project_new_page_tips_15") }}
                            </div>
                            <div class="option-list">
                                <template
                                    v-for="(item, index) in autoReplaceOpts"
                                >
                                    <div class="item" :key="index">
                                        <el-checkbox
                                            v-model="item.checked"
                                            :label="item.name"
                                        ></el-checkbox>
                                    </div>
                                </template>
                            </div>
                            <div class="block-title">
                                {{ $t("project.project_new_page_tips_13") }}
                            </div>
                            <div class="option-list">
                                <template
                                    v-for="(
                                        item, index
                                    ) in fileAnalysisSettingOpts"
                                >
                                    <div class="item" :key="index">
                                        <el-checkbox
                                            v-model="item.lock"
                                            :label="item.name"
                                        ></el-checkbox>
                                    </div>
                                </template>
                            </div>
                            <div class="block-title">
                                {{ $t("project.project_new_page_tips_14") }}
                            </div>
                            <div class="option-list">
                                <template
                                    v-for="(
                                        item, index
                                    ) in fileAnalysisSettingOpts"
                                >
                                    <div
                                        class="item"
                                        :key="index"
                                        v-if="
                                            ![
                                                'AUTO_REPLACE',
                                                'LOW_RISK_SENTENCE',
                                            ].includes(item.type)
                                        "
                                    >
                                        <el-checkbox
                                            v-model="item.calculate"
                                            :label="item.name"
                                        ></el-checkbox>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div
                        class="padding-t-15"
                        v-show="tabData.tabActiveIndex === 7"
                    >
                        <el-form label-width="100px" size="small">
                            <el-form-item>
                                <template slot="label">
                                    <span class="margin-r-5">{{
                                        $t(
                                            "project.project_new_page_form_label_9"
                                        )
                                    }}</span>
                                    <el-tooltip
                                        :content="
                                            $t(
                                                'project.project_new_page_tips_16'
                                            )
                                        "
                                        placement="top"
                                    >
                                        <svg-icon name="ib-question"></svg-icon>
                                    </el-tooltip>
                                </template>
                                <el-switch
                                    v-model="autoScoreSwitch"
                                    active-color="#1AC49C"
                                ></el-switch>
                            </el-form-item>
                            <el-form-item>
                                <template slot="label">
                                    <span class="margin-r-5">{{
                                        $t(
                                            "project.project_new_page_form_label_10"
                                        )
                                    }}</span>
                                    <el-tooltip
                                        :content="
                                            $t(
                                                'project.project_new_page_tips_17'
                                            )
                                        "
                                        placement="top"
                                    >
                                        <svg-icon name="ib-question"></svg-icon>
                                    </el-tooltip>
                                </template>
                                <el-input-number
                                    v-model="autoScoreThreshold"
                                    :step="10"
                                    :min="0"
                                    :max="90"
                                    :precision="0"
                                    controls-position="right"
                                ></el-input-number>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </el-card>
            <div class="action-content" v-if="activeStepIndex === 1">
                <el-button plain round @click="backBtnEvent">{{
                    $t("project.project_create_page_btn_text_7")
                }}</el-button>
                <el-button
                    type="primary"
                    round
                    @click="startTransitionBtnEvent"
                    :loading="startTranslationBtnLoading"
                    style="margin-left: 20px"
                    >{{
                        $t("project.project_create_page_btn_text_8")
                    }}</el-button
                >
            </div>
        </div>
        <multi-column-excel-parse-dialog
            ref="multiColumnExcelParseRef"
            @save="saveMultiColumnSetting"
        ></multi-column-excel-parse-dialog>
        <create-memory
            ref="createMemoryDialog"
            @success="createMemorySuccessEvent"
        ></create-memory>
        <create-term
            ref="createTermDialog"
            @success="createTermSuccessEvent"
        ></create-term>
        <alert-dialog
            ref="alertDialogDom"
            :message="alertInfo.message"
            :submessage="alertInfo.submessage"
            :type="alertInfo.type"
            :buttonName="alertInfo.buttonName"
            :buttonType="alertInfo.buttonType"
            @confirmEvent="confirmNextEvent"
        ></alert-dialog>
    </div>
</template>
<script>
import { debounce, cloneDeep } from "lodash";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";
import CreateUpload from "./components/CreateUpload.vue";
import JargonDialog from "@/components/JargonDialog";
import AlertDialog from "@/components/AlertDialog";
import PageTitle from "@/components/PageTitle";
import LanguageSelector from "@/components/LanguageSelector";
import CreateTerm from "@/views/project/components/CreateTermMultiLanguage";
import CreateMemory from "@/views/project/components/CreateMemoryMultiLanguage";
import LanguageDirection from "@/components/LanguageDirection";
import UploadOss from "@/components/UploadOss";
import config from "@/utils/config";
import tools from "@/utils/tools";
import {
    commonApi,
    projectApi,
    docApi,
    termApi,
    memoryApi,
    qaApi,
} from "@/utils/api";
import moment from "moment";
import MultiColumnExcelParseDialog from "./components/MultiColumnExcelParseDialog.vue";

export default {
    components: {
        JargonDialog,
        PageTitle,
        AlertDialog,
        LanguageSelector,
        CreateTerm,
        CreateMemory,
        CreateUpload,
        LanguageDirection,
        UploadOss,
        MultiColumnExcelParseDialog,
    },
    data() {
        return {
            uploadFileList: [],
            fileData: {},
            steps: [
                this.$t("project.project_create_page_data_steps_1"),
                this.$t("project.project_create_page_data_steps_2"),
            ],
            activeStepIndex: 0,
            nextBtnLoading: false,
            engineList: [],
            defaultProjectName: "",
            projectTemplate: "",

            form: {
                originValue: "zh",
                targetValue: [],
            },
            languageEngineList: [],
            defaultSelectedEngine: {
                key: "chatgpt",
                engine: null,
                name: "ChatGPT",
                icon: "chatgpt",
                sort: 100,
                domain: "general",
                modelType: null,
                modelId: null,
                enabled: true,
                commonly: false,
                proUsed: false,
            },

            startTranslationBtnLoading: false,
            advancedIsShow: false,
            memMatchingRate: 80,
            memMatchingOptions: [50, 60, 70, 80, 90, 100],
            writeableMemId: "",
            writeableTermId: "",
            tabData: {
                tabs: [
                    this.$t("project.project_create_page_data_tabData_tabs_1"),
                    this.$t("project.project_create_page_data_tabData_tabs_2"),
                    this.$t("project.project_create_page_data_tabData_tabs_3"),
                    this.$t("project.project_create_page_data_tabData_tabs_4"),
                    this.$t("project.project_create_page_data_tabData_tabs_5"),
                    this.$t("project.project_create_page_data_tabData_tabs_6"),
                    this.$t("project.project_create_page_data_tabData_tabs_7"),
                    this.$t("project.project_create_page_data_tabData_tabs_8"),
                ],
                tabActiveIndex: 0,
                termsList: [],
                termsTableSelection: [],
                memoryList: [],
                memoryTableSelection: [],
                memoryTableSelectionIds: [],
            },
            alertInfo: {
                message: this.$t(
                    "project.project_create_page_data_alertInfo_message_1"
                ),
                submessage: this.$t(
                    "project.project_create_page_data_alertInfo_submessage_1"
                ),
                type: "confirm", //alert ,confirm
                buttonName: this.$t(
                    "project.project_create_page_data_alertInfo_buttonName_1"
                ),
                buttonType: "primary",
            },

            createProjectApiSuccess: false,

            teamId: "",
            teamOptions: [],

            workflowOptions: [],
            translationProcess: "T",

            deadline: "",
            remark: "",
            remarkFileUpload: {
                show: false,
                loading: false,
                accept: "", //'.txt,.docx,.doc,.pdf,.rtf,.xlsx,.xls,.ppt,.pptx,.csv,.srt,.sdlxliff,.xliff,.cad,.dita,.ai,.indd,.mpp',
                supportFiles:
                    "txt/docx/doc/pdf/rtf/xlsx/xls/ppt/pptx/csv/srt/sdlxliff/xliff/cad/dita/ai/indd/mpp",
            },
            remarkFileList: [],
            docSplit: "SENTENCE",
            docSplitOpts: cloneDeep(config.DOC_SPLIT_OPTS),
            docSettingOpts: cloneDeep(config.DOC_SETTING_OPTS),
            fileAnalysisSettingOpts: cloneDeep(
                config.FILE_ANALYSIS_SETTING_OPTS
            ),
            autoReplaceOpts: cloneDeep(config.AUTO_REPLACE_OPTS),
            qaSetting: {
                basicList: [],
                aiList: [],
                checkQa: false,
            },
            //内部机构从CRM跳过来时有用
            projectInfo: {},

            referenceEngineList: [],
            projectTemplateOptions: [],

            autoScoreSwitch: false,
            autoScoreThreshold: 70,
            memLangValue: "",
            memLangMemoryList: {}, // {zh: {selected: [], list: []}}
            writeableLangMemId: "",
            termLangValue: "",
            termLangTermList: {}, // {zh: {selected: [], list: []}}
            multiColumnSettings: null,
        };
    },
    computed: {
        ...mapState({
            LANGUAGE_DICT: (state) => state.common.LANGUAGE_DICT,
            userInfo: (state) => state.user.userData,
        }),
    },

    methods: {
        async nextBtnEvent() {
            console.log(
                "nextBtnEvent:::",
                this.docSettingOpts,
                config.DOC_SETTING_OPTS,
                this.multiColumnSettings
            );
            if (this.activeStepIndex === 0) {
                let { fileList, fileData } =
                    this.$refs.createUploadDom.getValue();
                let keys = Object.keys(fileData || {});
                if (keys.length < fileList.length) {
                    this.$refs.alertDialogDom.setShow(true);
                } else {
                    if (keys.length > 0) {
                        let list = [];
                        keys.map((key) => {
                            list.push(fileData[key]);
                        });
                        if (list.length > 1) {
                            list.sort((a, b) => {
                                return a.size - b.size;
                            });
                        }
                        this.nextBtnLoading = true;
                        let url = `${docApi.getDocLanguage}?objectName=${list[0].objectName}`;
                        let res = await this.$ajax.get(url);
                        if (res.status === 200) {
                            let lang = res.data;
                            if (lang === "unknown") {
                                this.form.originValue = "zh";
                            } else {
                                this.form.originValue = lang;
                                if (lang === this.form.targetValue) {
                                    if (lang === "zh") {
                                        this.form.targetValue = "en";
                                    } else {
                                        this.form.targetValue = "zh";
                                    }
                                }
                            }
                            this.activeStepIndex = this.activeStepIndex + 1;
                            // console.log('nextBtn:::',this.uploadFileList[0])
                            let _name = fileList[0].name;
                            let _names = _name.split(".");
                            _names.pop();
                            this.defaultProjectName = _names
                                .join(".")
                                .substring(0, 200);
                            this.$nextTick(() => {
                                this.$refs.defaultProjectName.focus();
                            });
                            this.initProjectTemplateOptions();
                        }
                        this.nextBtnLoading = false;
                    } else {
                        if (fileList.length > 0) {
                            this.$message.error(
                                this.$t(
                                    "project.project_create_page_method_nextBtnEvent_message_1"
                                )
                            );
                        } else {
                            this.$message.error(
                                this.$t(
                                    "project.project_create_page_method_nextBtnEvent_message_2"
                                )
                            );
                        }
                    }
                }
            } else if (this.activeStepIndex === 1) {
                if (!this.selectedEngine) {
                    this.$message.error(
                        this.$t(
                            "project.project_create_page_method_nextBtnEvent_message_3"
                        )
                    );
                    return;
                }

                this.docSplit = "SENTENCE";
                if (this.selectedEngine.key === "chatgpt") {
                    this.docSplit = "PARAGRAPH";
                }

                this.activeStepIndex = this.activeStepIndex + 1;
                this.$nextTick(() => {
                    this.$refs.defaultProjectName.focus();
                });
            } else {
                this.activeStepIndex = this.activeStepIndex + 1;
            }
        },
        confirmNextEvent() {
            let { fileList, fileData } = this.$refs.createUploadDom.getValue();
            let keys = Object.keys(fileData || {});
            if (keys.length > 0) {
                let list = [];
                keys.map((key) => {
                    list.push(fileData[key]);
                });
                if (list.length > 1) {
                    list.sort((a, b) => {
                        return a.size - b.size;
                    });
                }
                let url = `${docApi.getDocLanguage}?objectName=${list[0].objectName}`;
                this.nextBtnLoading = true;
                this.$ajax
                    .get(url)
                    .then((res) => {
                        if (res.status === 200) {
                            let lang = res.data;
                            if (lang === "unknown") {
                                this.form.originValue = "zh";
                            } else {
                                this.form.originValue = lang;
                                if (lang === this.form.targetValue) {
                                    if (lang === "zh") {
                                        this.form.targetValue = "en";
                                    } else {
                                        this.form.targetValue = "zh";
                                    }
                                }
                            }
                            this.activeStepIndex = 1;
                            let _name = fileList[0].name;
                            let _names = _name.split(".");
                            _names.pop();
                            if (!this.defaultProjectName) {
                                this.defaultProjectName = _names
                                    .join(".")
                                    .substring(0, 200);
                            }
                        }
                    })
                    .finally(() => {
                        this.nextBtnLoading = false;
                    });
            } else {
                if (fileList.length > 0) {
                    this.$message.error(
                        this.$t(
                            "project.project_create_page_method_confirmNextEvent_message_1"
                        )
                    );
                } else {
                    this.$message.error(
                        this.$t(
                            "project.project_create_page_method_confirmNextEvent_message_2"
                        )
                    );
                }
            }
        },

        backBtnEvent() {
            this.activeStepIndex = this.activeStepIndex - 1;
        },
        /**
         * 开始翻译按钮事件
         */
        startTransitionBtnEvent: debounce(function () {
            let self = this;
            if (!this.defaultProjectName) {
                this.$message.error(
                    this.$t(
                        "project.project_create_page_method_startTransitionBtnEvent_message_1"
                    )
                );
                return;
            }
            if (!this.deadline) {
                this.$message.error(
                    this.$t(
                        "project.project_create_page_method_startTransitionBtnEvent_message_2"
                    )
                );
                return;
            }
            if (this.form.targetValue.length == 0) {
                this.$message.error(
                    this.$t(
                        "project.project_create_page_method_startTransitionBtnEvent_message_3"
                    )
                );
                return;
            }
            // console.log (this.languageEngineList);
            let vEngines = this.languageEngineList.filter(
                (item) => item.engine === null
            );
            if (vEngines.length > 0) {
                this.$message.error(
                    this.$t(
                        "project.project_create_page_method_startTransitionBtnEvent_message_4"
                    )
                );
                return;
            }
            let docSetting = {};
            this.docSettingOpts.map((item) => {
                item.options.map((opt) => {
                    docSetting[opt.key] = opt.value;
                });
            });
            // 多列Excel校验
            if (docSetting["multiColumn"]) {
                let vmc = this.validateMultiColumnSettings();
                if (!vmc) {
                    this.showMultiColumnExcelParseDialogEvent();
                    return;
                }
            }
            docSetting["multiColumnSettings"] = this.multiColumnSettings;
            let url = projectApi.startTranslation;
            let docs = [];
            if (this.projectInfo && this.projectInfo.docs) {
                docs = this.projectInfo.docs;
            } else {
                let keys = Object.keys(this.fileData || {});
                keys.map((key) => {
                    docs.push(this.fileData[key]);
                });
            }
            let postData = {
                projectName: this.defaultProjectName,
                templateId: this.projectTemplate,
                teamId: this.teamId,
                deadline: moment(this.deadline).format("YYYY-MM-DD HH:mm:ss"),
                remark: this.remark,
                docs: docs,
                styleGuideDocs: this.remarkFileList,
            };
            if (this.projectInfo) {
                postData.externalProjectId = this.projectInfo.externalProjectId;
            }
            let multilingualSetting = [];
            let termIds = [];
            let writeableTermId = [];
            Object.values(this.termLangTermList).map((item) => {
                termIds = termIds.concat(item.ids);
                if (item.writeableTermId) {
                    writeableTermId.push(item.writeableTermId);
                }
            });
            /* this.tabData.termsTableSelection.map((item) => {
				termIds.push(item.termId);
			}); */

            let memIds = []; //this.tabData.memoryTableSelectionIds;
            let mems = [];
            let writeableMemId = [];
            Object.values(this.memLangMemoryList).map((item) => {
                memIds = memIds.concat(item.ids);
                if (item.writeableMemId) {
                    writeableMemId.push(item.writeableMemId);
                }
                memIds.map((id) => {
                    let mem = item.list.find((it) => it.memId === id);
                    if (mem)
                        mems.push({ memId: mem.memId, penalties: mem.setting });
                });
            });
            /* this.tabData.memoryTableSelection.map((item) => {
				mems.push({memId: item.memId, penalties: item.setting});
			}); */
            let projectSetting = {
                docSetting,
                translationProcess: this.translationProcess,
                writeableTermId,
                writeableMemId,
                analysisSettings: this.fileAnalysisSettingOpts,
                autoReplaceSettings: this.autoReplaceOpts,
                ratingSettings: {
                    enable: this.autoScoreSwitch,
                    threshold: this.autoScoreThreshold,
                },
            };
            this.languageEngineList.map((item) => {
                multilingualSetting.push({
                    sourceLang: this.form.originValue,
                    targetLang: item.target,
                    enableAiTrans: item.engine !== "NONE",
                    engine:
                        item.engine !== "NONE" && item.engine.key
                            ? item.engine.key.split("@")[0]
                            : null,
                    modelId:
                        item.engine !== "NONE" && item.engine.modelId
                            ? item.engine.modelId
                            : null,
                    domain: item.engine !== "NONE" ? item.engine.domain : null,
                    randomEngine: item.referenceEngine
                        ? item.referenceEngine.key
                        : null,
                    termIds,
                    memIds,
                    mems,
                    memMatchingRate: this.memMatchingRate,
                });
            });
            projectSetting["multilingualSetting"] = multilingualSetting;
            //QA
            //projectSetting['qaSetting'] = {options: [].concat(this.qaSetting.basicList, this.qaSetting.aiList)};
            let optionsObject = {};
            []
                .concat(this.qaSetting.basicList, this.qaSetting.aiList)
                .forEach((option) => {
                    optionsObject[option.code] = option.selected;
                });
            projectSetting["qaSetting"] = {
                selected: optionsObject,
                checkQa: this.qaSetting.checkQa,
            };

            postData.projectSetting = projectSetting;
            // console.log('postData::', postData);
            // return;
            this.startTranslationBtnLoading = true;
            this.$ajax
                .post(url, postData)
                .then((res) => {
                    if (res.status === 200) {
                        setTimeout(() => {
                            this.resetData();
                            this.createProjectApiSuccess = true;
                            location.href = "/project/index";
                        }, 1000);
                    }
                })
                .finally(() => {
                    this.startTranslationBtnLoading = false;
                });
        }),

        async initTargetLangMemoryList(
            targetLang,
            newIds = [],
            setting = null,
            sortParams = {}
        ) {
            if (!targetLang) return;
            // this.memLangValue = targetLang;
            let url =
                `${memoryApi.memoryDB}?pageNumber=1&pageSize=1000&type=new` +
                `&sourceLang=${this.form.originValue}&targetLang=${targetLang}&teamId=${this.teamId}`;

            // 添加排序参数
            if (sortParams && sortParams.sort) {
                url += `&sort=${sortParams.sort}`;
                console.log("Create.vue - 记忆库排序URL:", url);
            }
            try {
                let memLangMemory = this.memLangMemoryList[targetLang];
                // console.log('this.memLangMemoryList-1-1-1::::', targetLang, newIds, setting);
                let res = await this.$ajax.get(url);
                if (res.status === 200) {
                    let _list = [];
                    let _selected = [];
                    let _ids = [];
                    let _writeableMemId = "";
                    if (setting) {
                        // 数据来源为模板时
                        res.data.records.map((item) => {
                            let _mem = setting.mems.find(
                                (mem) => String(mem.memId) === item.memId
                            );
                            let _item = {
                                ...item,
                                setting: _mem ? _mem.penalties : item.setting,
                            };
                            _list.push(_item);
                            if (
                                newIds.length &&
                                newIds.indexOf(_item.memId) > -1
                            ) {
                                _selected.push(_item);
                            }
                            if (
                                setting.writeableMemId.indexOf(_item.memId) > -1
                            ) {
                                _writeableMemId = _item.memId;
                            }
                        });
                        // console.log('this.memLangMemoryList0000::', _writeableMemId, _selected);
                    } else if (memLangMemory) {
                        res.data.records.map((item) => {
                            let _index = memLangMemory.list.findIndex(
                                (it) => it.memId === item.memId
                            );
                            if (_index > -1) {
                                _list.push({
                                    ...item,
                                    setting: memLangMemory.list[_index].setting,
                                });
                            } else {
                                _list.push(item);
                            }
                            let _index_2 = memLangMemory.selected.findIndex(
                                (it) => it.memId === item.memId
                            );
                            if (_index_2 > -1) {
                                _selected.push(
                                    memLangMemory.selected[_index_2]
                                );
                            }
                            if (
                                newIds.length &&
                                newIds.indexOf(item.memId) > -1
                            ) {
                                _selected.push(item);
                            }
                        });
                        _writeableMemId = memLangMemory.writeableMemId;
                    } else {
                        _list = res.data.records;
                    }
                    _ids = _selected.map((it) => it.memId);
                    this.memLangMemoryList[targetLang] = {
                        selected: _selected,
                        writeableMemId: _writeableMemId,
                        ids: _ids,
                        list: _list,
                    };
                    // console.log('this.memLangMemoryList11----_selected::', memLangMemory?.selected, _selected);
                    // console.log('this.memLangMemoryList22222::', this.memLangMemoryList);
                    if (targetLang === this.memLangValue) {
                        this.tabData.memoryTableSelectionIds = _ids;
                        this.writeableLangMemId = _writeableMemId;
                        this.tabData.memoryList = _list;
                        this.$nextTick(() => {
                            // console.log('this.memLangMemoryList3333::nextTick::', this.tabData.memoryList)
                            _ids.map((id) => {
                                let item = _list.find((it) => it.memId === id);
                                if (item)
                                    this.$refs.memoryTable.toggleRowSelection(
                                        item,
                                        true
                                    );
                            });
                        });
                    }
                }
            } catch (error) {}
        },
        memLangSelectChange(lang) {
            this.initTargetLangMemoryList(lang);
        },
        createMemorySuccessEvent(ids) {
            this.form.targetValue.map((lang) => {
                this.initTargetLangMemoryList(lang, ids);
            });
        },
        handleMemoryWriteChange(val, row) {
            if (val) {
                this.writeableLangMemId = row.memId;
                this.memLangMemoryList[this.memLangValue].writeableMemId =
                    row.memId;
                this.$refs.memoryTable.toggleRowSelection(row, true);
            } else {
                this.writeableLangMemId = "";
                this.memLangMemoryList[this.memLangValue].writeableMemId = "";
            }
        },
        handleMemoryTableSelectionChange(val) {
            // console.log('handleMemoryTableSelectionChange:::::', val, this.memLangMemoryList);
            let ids = val.map((item) => item.memId);
            this.tabData.memoryTableSelectionIds = ids;
            this.memLangMemoryList[this.memLangValue].selected = val;
            this.memLangMemoryList[this.memLangValue].ids = ids;
        },
        gotoMemoryPage() {
            if (this.form.targetValue.length === 0) {
                this.$message.warning(
                    this.$t(
                        "project.project_create_page_method_gotoMemoryPage_message_2"
                    )
                );
                return;
            }
            let list = [];
            this.form.targetValue.map((target) => {
                list.push({
                    source: this.form.originValue,
                    target,
                    object: {},
                });
            });
            this.$refs.createMemoryDialog.setShow({ list });
        },
        async initTargetLangTermList(
            targetLang,
            newIds = [],
            setting = null,
            sortParams = {}
        ) {
            if (!targetLang) return;
            let url =
                `${termApi.termDB}?pageNumber=1&pageSize=1000` +
                `&sourceLang=${this.form.originValue}&targetLang=${targetLang}&teamId=${this.teamId}`;

            // 添加排序参数
            if (sortParams && sortParams.sort) {
                url += `&sort=${sortParams.sort}`;
                console.log("Create.vue - 术语库排序URL:", url);
            }
            try {
                let termLangTerm = this.termLangTermList[targetLang];
                let res = await this.$ajax.get(url);
                // console.log('termLangTerm:---', termLangTerm, this.termLangTermList, res)
                if (res.status === 200) {
                    let _list = res.data.records;
                    let _selected = [];
                    let _ids = [];
                    let _writeableTermId = "";
                    if (setting) {
                        res.data.records.map((item) => {
                            if (
                                newIds.length &&
                                newIds.indexOf(item.termId) > -1
                            ) {
                                _selected.push(item);
                            }
                            if (
                                setting.writeableTermId &&
                                setting.writeableTermId.length &&
                                setting.writeableTermId.indexOf(item.termId) >
                                    -1
                            ) {
                                _writeableTermId = item.termId;
                            }
                        });
                    } else if (termLangTerm) {
                        res.data.records.map((item) => {
                            let _index_2 = termLangTerm.selected.findIndex(
                                (it) => it.termId === item.termId
                            );
                            if (_index_2 > -1) {
                                _selected.push(termLangTerm.selected[_index_2]);
                            }
                            if (
                                newIds.length &&
                                newIds.indexOf(item.termId) > -1
                            ) {
                                _selected.push(item);
                            }
                        });
                        _writeableTermId = termLangTerm.writeableTermId;
                    } else {
                        _list = res.data.records;
                    }
                    _ids = _selected.map((it) => it.termId);
                    this.termLangTermList[targetLang] = {
                        selected: _selected,
                        writeableTermId: _writeableTermId,
                        ids: _ids,
                        list: _list,
                    };
                    // console.log('initTargetLangTermList:::===', this.termLangTermList)
                    if (targetLang === this.termLangValue) {
                        this.tabData.termsTableSelection = _ids;
                        this.writeableTermId = _writeableTermId;
                        this.tabData.termsList = _list;
                        this.$nextTick(() => {
                            // console.log('nextTick:::===', _ids)
                            _ids.map((id) => {
                                let item = _list.find((it) => it.termId === id);
                                if (item)
                                    this.$refs.termsTable.toggleRowSelection(
                                        item,
                                        true
                                    );
                            });
                        });
                    }
                }
            } catch (error) {}
        },

        termLangSelectChange(lang) {
            // console.log('termLangSelectChange::', lang)
            this.initTargetLangTermList(lang);
        },
        createTermSuccessEvent(ids) {
            this.form.targetValue.map((lang) => {
                this.initTargetLangTermList(lang, ids);
            });
        },

        handleTermWriteChange(val, row) {
            if (val) {
                this.writeableTermId = row.termId;
                this.termLangTermList[this.termLangValue].writeableTermId =
                    row.termId;
                this.$refs.termsTable.toggleRowSelection(row, true);
            } else {
                this.writeableTermId = "";
                this.termLangTermList[this.termLangValue].writeableTermId = "";
            }
        },
        handleTermsTableSelectionChange(val) {
            let ids = val.map((item) => item.termId);
            this.tabData.termsTableSelection = ids;
            this.termLangTermList[this.termLangValue].selected = val;
            this.termLangTermList[this.termLangValue].ids = ids;
        },

        getMemoryPenaltyPointsInputStatus(row) {
            return this.tabData.memoryTableSelectionIds.indexOf(row.memId) < 0;
        },
        handleMemoryPenaltyPointsChange(val, row) {
            // console.log(val, row);
            let index = this.tabData.memoryTableSelection.findIndex(
                (item) => item.memId === row.memId
            );
            this.tabData.memoryTableSelection.splice(index, 1, row);
        },
        gotoTermPage() {
            if (this.form.targetValue.length === 0) {
                this.$message.warning(
                    this.$t(
                        "project.project_create_page_method_gotoTermPage_message_1"
                    )
                );
                return;
            }
            let list = [];
            this.form.targetValue.map((target) => {
                list.push({
                    source: this.form.originValue,
                    target,
                    object: {},
                });
            });
            this.$refs.createTermDialog.setShow({ list });
        },

        docSettingCheckAllChange(val, index) {
            this.docSettingOpts[index]["checkAll"] = val;
            this.docSettingOpts[index]["indeterminate"] = false;
            let tmpOptions = this.docSettingOpts[index]["options"];
            tmpOptions.map((opt, oIndex) => {
                tmpOptions[oIndex]["value"] = val;
            });
            this.docSettingOpts[index]["options"] = tmpOptions;
        },
        docSettingCheckChange(val, index, oIndex) {
            let checkedCount = 0;
            this.docSettingOpts[index]["options"][oIndex]["value"] = val;
            let options = this.docSettingOpts[index]["options"];
            options.map((opt) => {
                if (opt.value === true) {
                    checkedCount = checkedCount + 1;
                }
            });
            this.docSettingOpts[index]["checkAll"] =
                checkedCount === options.length;
            this.docSettingOpts[index]["indeterminate"] =
                checkedCount > 0 && checkedCount < options.length;
        },
        showMultiColumnExcelParseDialogEvent() {
            if (this.form.targetValue.length === 0) {
                this.$message.warning(
                    this.$t(
                        "project.project_create_page_method_showMultiColumnExcelParseDialogEvent_message_1"
                    )
                );
                return;
            }
            let settings = {
                notParseFirstRow: false,
                source: { lang: this.form.originValue, col: "" },
                targets: this.form.targetValue.map((lang) => ({
                    lang,
                    col: "",
                })),
                translationNotes: "",
                charLimit: "",
            };
            if (this.multiColumnSettings) {
                settings.notParseFirstRow =
                    this.multiColumnSettings.notParseFirstRow;
                if (
                    this.multiColumnSettings.source.lang ===
                    settings.source.lang
                ) {
                    settings.source = { ...this.multiColumnSettings.source };
                }
                this.multiColumnSettings.targets.map((item) => {
                    let tIndex = settings.targets.findIndex(
                        (t) => t.lang === item.lang
                    );
                    if (tIndex > -1) {
                        settings.targets[tIndex] = { ...item };
                    }
                });
                settings.translationNotes =
                    this.multiColumnSettings.translationNotes || "";
                settings.charLimit = this.multiColumnSettings.charLimit || "";
            }
            this.$refs.multiColumnExcelParseRef.setShow({
                ...settings,
                enable: true,
            });
        },
        saveMultiColumnSetting(settings) {
            this.multiColumnSettings = settings;
        },
        validateMultiColumnSettings() {
            if (!this.multiColumnSettings) {
                setTimeout(() => {
                    this.$message.error(
                        this.$t(
                            "project.project_create_page_method_validateMultiColumnSettings_message_1"
                        )
                    );
                }, 100);
                return false;
            }
            let emptyTargets = this.multiColumnSettings.targets.filter(
                (item) => !item.col
            );
            let tLangs = this.multiColumnSettings.targets.filter(
                (item) => !this.form.targetValue.includes(item.lang)
            );
            if (
                !this.multiColumnSettings.source.col ||
                emptyTargets.length > 0 ||
                this.multiColumnSettings.targets.length !==
                    this.form.targetValue.length ||
                tLangs.length > 0
            ) {
                setTimeout(() => {
                    this.$message.error(
                        this.$t(
                            "project.project_create_page_method_validateMultiColumnSettings_message_2"
                        )
                    );
                }, 100);
                return false;
            }
            return true;
        },
        initQASetting() {
            let url = `${qaApi.queryQaConfig}`;
            this.$ajax.get(url).then((res) => {
                if (res.status === 200) {
                    let list = res.data.options;
                    list.map((item) => {
                        if (item.type === "BASIC") {
                            this.qaSetting.basicList.push(item);
                        } else if (item.type === "AI") {
                            this.qaSetting.aiList.push(item);
                        }
                    });
                }
            });
        },
        initReferenceEngineList(item) {
            // console.log(item);
            let postData = {
                sourceLang: this.form.originValue,
                targetLang: item.target,
            };
            if (item.engine !== "NONE") {
                postData = {
                    ...postData,
                    domain: item.engine.domain,
                    engine: item.engine.key.split("@")[0],
                    modelId: item.engine.modelId
                        ? item.engine.modelId
                        : undefined,
                };
            }
            let url = projectApi.queryReferenceEngineList;
            this.$ajax.post(url, postData).then((res) => {
                if (res.status === 200) {
                    item.referenceOptions = res.data;
                }
            });
        },
        settingTabEvent(item, index) {
            this.tabData.tabActiveIndex = index;
        },
        queryWorkflowOptions() {
            let url = projectApi.queryWorkflowList;
            this.$ajax.get(url).then((res) => {
                if (res.status === 200) {
                    this.workflowOptions = res.data;
                }
            });
        },
        queryTeamOptions() {
            let url = commonApi.queryTeamFilterOptions;
            this.$ajax.get(url).then((res) => {
                if (res.status === 200) {
                    this.teamOptions = res.data.teamFilters;
                    this.teamId = this.teamOptions[0].value;
                }
            });
        },
        teamChangeEvent() {
            if (this.form.targetValue.length) {
                this.initMemoryAndTermData();
                this.memLangValue = this.form.targetValue[0] || "";
                this.termLangValue = this.form.targetValue[0] || "";
                this.form.targetValue.map((lang) => {
                    this.initTargetLangMemoryList(lang);
                    this.initTargetLangTermList(lang);
                });
            }
        },

        // 内部机构从CRM跳转到Lanx新建项目
        initProjectInfo() {
            let url = `${projectApi.queryProjectInitData}?id=${this.$route.query.projectId}&userId=${this.$route.query.uId}`;
            this.$ajax.get(url).then((res) => {
                if (res.status === 200) {
                    this.projectInfo = res.data;
                    this.form.originValue = res.data.sourceLang;
                    this.form.targetValue = res.data.targetLang
                        ? res.data.targetLang.split(",")
                        : [];
                    this.defaultProjectName = res.data.projectName.substring(
                        0,
                        200
                    );
                    this.remarkFileList = res.data.styleGuideDocs || [];
                    this.deadline = res.data.endDate || "";
                    this.$nextTick(() => {
                        this.targetValueChangeEvent(this.form.targetValue);
                        this.activeStepIndex = 1;
                    });
                }
            });
        },
        originValueChangeEvent(value) {
            let tIndex = this.form.targetValue.findIndex(
                (item) => item === value
            );
            if (tIndex > -1) {
                this.form.targetValue.splice(tIndex, 1);
            }
            let eIndex = this.languageEngineList.findIndex(
                (item) => item.target === value
            );
            if (eIndex > -1) {
                this.languageEngineList.splice(eIndex, 1);
            }
            if (this.form.targetValue.length) {
                this.memLangMemoryList = {};
                this.termLangTermList = {};
                this.memLangValue = this.form.targetValue[0] || "";
                this.termLangValue = this.form.targetValue[0] || "";
                this.form.targetValue.map((lang) => {
                    this.initTargetLangMemoryList(lang);
                    this.initTargetLangTermList(lang);
                });
            } else {
                this.initMemoryAndTermData();
            }
        },
        // 目标语言改变事件
        targetValueChangeEvent(value) {
            // console.log('targetValueChangeEvent::', value);
            let list = [];
            if (value && value.length > 0) {
                value.map(async (item) => {
                    let langEngine = this.languageEngineList.find(
                        (lang) => lang.target === item
                    );
                    if (langEngine) {
                        list.push(langEngine);
                    } else {
                        let url = `${projectApi.queryEnginesAndRecommendByLang}?&sourceLang=${this.form.originValue}&targetLang=${item}`;
                        const res = await this.$ajax.get(url);
                        list.push({
                            target: item,
                            engine: res.data.recommendationEngine,
                            options: res.data.domainEngines,
                            referenceEngine: null,
                            referenceOptions: [],
                        });
                    }
                });
                this.memLangValue = value.at(-1);
                this.initTargetLangMemoryList(value.at(-1));
                this.termLangValue = value.at(-1);
                this.initTargetLangTermList(value.at(-1));
            } else {
                this.initMemoryAndTermData();
            }
            this.languageEngineList = list;

            // this.initMemoryList();
            // this.initTermsList();
        },
        initMemoryAndTermData() {
            this.memLangValue = "";
            this.memLangMemoryList = {};
            this.termLangValue = "";
            this.termLangTermList = {};
            this.tabData.termsTableSelection = [];
            this.writeableTermId = "";
            this.tabData.termsList = [];
            this.tabData.memoryTableSelectionIds = [];
            this.writeableLangMemId = "";
            this.tabData.memoryList = [];
        },

        compareEngine(param) {
            let url = `/tools/translationScore/index`; //?source=${param.source}&target=${param.target}
            window.open(url, "_blank");
        },
        /* loadEngineList(item){
            let url = `${projectApi.queryEnginesByLang}?&sourceLang=${this.form.originValue}&targetLang=${item.target}`;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    item.options = res.data;
                }
            })
        }, */
        submitUploadRemarkFile() {
            let files = this.$refs.remarkFileUploadDom.getOssFiles();
            let list = [];
            files.map((item) => {
                list.push({
                    ...item,
                    time: moment().format("YYYY-MM-DD HH:mm:ss"),
                });
            });
            this.remarkFileList = this.remarkFileList.concat(list);
            this.remarkFileUpload.loading = false;
            this.remarkFileUpload.show = false;
        },
        deleteRemarkFile(scope) {
            let index = scope.$index;
            this.remarkFileList.splice(index, 1);
        },
        initProjectTemplateOptions() {
            let url = projectApi.queryTemplateOptions;
            this.$ajax.get(url).then((res) => {
                if (res.status === 200) {
                    this.projectTemplateOptions = res.data;
                }
            });
        },
        projectTemplateChangeEvent(val) {
            // 初始化项目模板
            // this.writeableMemId = [];
            // this.writeableTermId = [];
            let url = `${projectApi.queryTemplateDetail}?id=${val}`;
            this.$ajax.get(url).then(async (res) => {
                if (res.status === 200) {
                    this.translationProcess = res.data.translationProcessMode;
                    this.teamId = res.data.teamId;
                    this.form.originValue = res.data.sourceLang.key;
                    this.form.targetValue = res.data.targetLang.map(
                        (item) => item.key
                    );
                    let projectSetting = res.data.templateData.projectSetting;
                    // 模型相关
                    let list = [];
                    projectSetting.multilingualSetting.map(async (setting) => {
                        // 语言模型
                        let eurl = `${projectApi.queryEnginesAndRecommendByLang}?&sourceLang=${this.form.originValue}&targetLang=${setting.targetLang}`;
                        const eres = await this.$ajax.get(eurl);
                        let _engineList = [];
                        eres.data.domainEngines.map((domain) => {
                            _engineList = _engineList.concat(domain.engines);
                        });
                        let _engine = _engineList.find(
                            (engine) => engine.key === setting.engine
                        );
                        // 参考模型
                        let rePostData = {
                            sourceLang: setting.sourceLang,
                            targetLang: setting.targetLang,
                            domain: setting.domain,
                            engine: setting.engine,
                            modelId: setting.modelId
                                ? setting.modelId
                                : undefined,
                        };
                        let reRes = await this.$ajax.post(
                            projectApi.queryReferenceEngineList,
                            rePostData
                        );
                        let _reEngineList = [];
                        reRes.data.map((domain) => {
                            _reEngineList = _reEngineList.concat(
                                domain.engines
                            );
                        });
                        let _reEngine = _reEngineList.find(
                            (engine) => engine.key === setting.randomEngine
                        );
                        list.push({
                            target: setting.targetLang,
                            engine: _engine || "NONE",
                            options: eres.data.domainEngines,
                            referenceEngine: _reEngine,
                            referenceOptions: reRes.data,
                        });
                    });
                    this.languageEngineList = list;
                    this.initMemoryAndTermData();
                    // 记忆库
                    let memIds =
                        projectSetting.multilingualSetting[0].memIds || [];
                    let mems = projectSetting.multilingualSetting[0].mems || [];
                    this.memMatchingRate =
                        projectSetting.multilingualSetting[0].memMatchingRate;
                    this.memLangValue = this.form.targetValue[0];
                    // console.log('projectTemplateChangeEvent::mem::', memIds, mems, projectSetting.writeableMemId);
                    this.form.targetValue.map((langKey) => {
                        this.initTargetLangMemoryList(langKey, memIds, {
                            mems,
                            writeableMemId: projectSetting.writeableMemId || [],
                        });
                    });
                    // this.initMemoryList({ids: memIds, mems});
                    // 术语库
                    let termIds =
                        projectSetting.multilingualSetting[0].termIds || [];
                    this.termLangValue = this.form.targetValue[0];
                    this.form.targetValue.map((langKey) => {
                        this.initTargetLangTermList(langKey, termIds, {
                            writeableTermId:
                                projectSetting.writeableTermId || [],
                        });
                    });
                    // this.initTermsList({ids: termIds});
                    // 文档设置
                    this.docSettingOpts = cloneDeep(
                        config.DOC_SETTING_OPTS
                    ).map((item) => {
                        item.options = item.options.map((opt) => {
                            return {
                                ...opt,
                                value: projectSetting.docSetting[opt.key],
                            };
                        });
                        return item;
                    });
                    // 多列Excel解析设置
                    this.multiColumnSettings =
                        projectSetting.docSetting.multiColumnSettings;
                    // 自动替换设置
                    let _autoReplaceOpts = [];
                    this.autoReplaceOpts.map((item) => {
                        let opt = projectSetting.autoReplaceSettings.find(
                            (o) => o.type === item.type
                        );
                        _autoReplaceOpts.push({ ...item, ...opt });
                    });
                    this.autoReplaceOpts = _autoReplaceOpts;
                    // 自动评分设置
                    this.autoScoreSwitch =
                        projectSetting.ratingSettings?.enable;
                    this.autoScoreThreshold =
                        projectSetting.ratingSettings?.threshold;
                    // QA设置
                    let _qaSetting = projectSetting.qaSetting.selected;
                    this.qaSetting.basicList = this.qaSetting.basicList.map(
                        (opt) => {
                            return {
                                ...opt,
                                selected: _qaSetting[opt.code]
                                    ? _qaSetting[opt.code]
                                    : false,
                            };
                        }
                    );
                    this.qaSetting.aiList = this.qaSetting.aiList.map((opt) => {
                        return {
                            ...opt,
                            selected: _qaSetting[opt.code]
                                ? _qaSetting[opt.code]
                                : false,
                        };
                    });
                    this.qaSetting.checkQa =
                        projectSetting.qaSetting.checkQa || false;
                    // 风格指南
                    this.remark = res.data.remark;
                    this.remarkFileList = JSON.parse(
                        res.data.templateData.styleGuideDocs
                    );
                    // 高级设置
                    this.fileAnalysisSettingOpts =
                        this.fileAnalysisSettingOpts.map((item) => {
                            let _value = projectSetting.analysisSettings.find(
                                (v) => v.type === item.type
                            );
                            return { ...item, ..._value };
                        });
                    await tools.sleep(1100);
                    // this.writeableMemId = projectSetting.writeableMemId;
                    // this.writeableTermId = projectSetting.writeableTermId;
                }
            });
        },

        resetData() {
            this.multiColumnSettings = null;
            this.docSettingOpts = [];
        },

        // 记忆库排序处理
        handleMemorySortChange({ column, prop, order }) {
            console.log("Create.vue - 记忆库排序:", { column, prop, order });

            // 修复prop为undefined的情况，使用columnKey作为后备
            let actualProp = prop;
            if (!actualProp && column && column.columnKey) {
                actualProp = column.columnKey;
                console.log(
                    "Create.vue - 记忆库排序: 使用columnKey作为prop:",
                    actualProp
                );
            }

            let sortField = "";
            if (actualProp === "name") {
                sortField = "name";
            } else if (actualProp === "nums") {
                sortField = "nums";
            } else if (actualProp === "createTime") {
                sortField = "createAt";
            }

            console.log("Create.vue - 记忆库排序字段:", sortField);

            let sortParams = {};
            if (sortField && order) {
                let sortDirection = order === "ascending" ? "asc" : "desc";
                sortParams.sort = `${sortField}:${sortDirection}`;
                console.log("Create.vue - 记忆库排序参数:", sortParams);
            } else {
                sortParams.sort = "";
                console.log("Create.vue - 记忆库排序清除");
            }

            // 清除数据缓存，确保重新请求
            this.memLangMemoryList[this.memLangValue] = null;
            this.initTargetLangMemoryList(
                this.memLangValue,
                [],
                null,
                sortParams
            );
        },

        // 术语库排序处理
        handleTermsSortChange({ column, prop, order }) {
            console.log("Create.vue - 术语库排序:", { column, prop, order });

            // 修复prop为undefined的情况，使用columnKey作为后备
            let actualProp = prop;
            if (!actualProp && column && column.columnKey) {
                actualProp = column.columnKey;
                console.log(
                    "Create.vue - 术语库排序: 使用columnKey作为prop:",
                    actualProp
                );
            }

            let sortField = "";
            if (actualProp === "name") {
                sortField = "name";
            } else if (actualProp === "nums") {
                sortField = "nums";
            } else if (actualProp === "createTime") {
                sortField = "createAt";
            }

            console.log("Create.vue - 术语库排序字段:", sortField);

            let sortParams = {};
            if (sortField && order) {
                let sortDirection = order === "ascending" ? "asc" : "desc";
                sortParams.sort = `${sortField}:${sortDirection}`;
                console.log("Create.vue - 术语库排序参数:", sortParams);
            } else {
                sortParams.sort = "";
                console.log("Create.vue - 术语库排序清除");
            }

            // 清除数据缓存，确保重新请求
            this.termLangTermList[this.termLangValue] = null;
            this.initTargetLangTermList(
                this.termLangValue,
                [],
                null,
                sortParams
            );
        },

        executeAction(action, params) {
            switch (action) {
                case "updateLang":
                    this.form = { ...this.form, ...params };
                    break;
                case "updateFile":
                    this.uploadFileList = params.fileList;
                    this.fileData = params.fileData;
                    break;
            }
            this.$forceUpdate();
        },
    },
    beforeRouteLeave: function (to, from, next) {
        try {
            if (!this.createProjectApiSuccess) {
                if (this.uploadFileList.length > 0) {
                    // next(false);
                    this.$confirm(
                        this.$t(
                            "project.project_create_page_method_beforeRouteLeave_message_1"
                        ),
                        this.$t(
                            "project.project_create_page_method_beforeRouteLeave_message_2"
                        ),
                        {
                            cancelButtonText: this.$t(
                                "project.project_create_page_method_beforeRouteLeave_btn_1"
                            ),
                            confirmButtonText: this.$t(
                                "project.project_create_page_method_beforeRouteLeave_btn_2"
                            ),
                            type: "warning",
                        }
                    ).then(() => {
                        next();
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        } catch (e) {
            console.error("页面跳转提醒：", e);
        }
    },
    created() {
        // let _docSetting = cloneDeep(config.DOC_SETTING_OPTS)
        // _docSetting[1]['options'][2]['value'] = false; // 默认关闭多列Excel解析
        // console.log('_docSetting:::', _docSetting);
        // this.docSettingOpts = cloneDeep(config.DOC_SETTING_OPTS);
        let query = this.$route.query;
        if (query && query.source === "crm" && query.projectId) {
            this.initProjectInfo();
        }
        this.initQASetting();
    },
    mounted() {
        // this.initProjectTemplateOptions();
        this.queryWorkflowOptions();
        this.queryTeamOptions();
    },
    beforeDestroy() {
        this.resetData();
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.index-page {
    // position: relative;
    // margin: 20px;
    display: flex;
    height: 100%;
    flex-direction: column;
    .try-content {
        ::v-deep .el-textarea__inner {
            height: 100%;
            border: none;
            background-color: inherit;
            padding: 20px;
            font-size: 14px;
            color: #000000;
        }
        p {
            line-height: 22px;
            &:empty {
                height: 22px;
            }
        }
    }
    .steps-content {
        width: 100%;
        display: flex;
        margin-top: 30px;
        justify-content: center;
        .step-item {
            display: flex;
            font-size: 15px;
            color: #00000066;
            &.active {
                .step-name {
                    font-weight: 600;
                    color: #000;
                }
            }
            .step-arrow {
                width: 44px;
                text-align: center;
            }
        }
    }
    .upload-content {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .next-btn {
        text-align: center;
        margin-top: 20px;
        height: 40px;
    }
    .engine-content {
        margin-top: 40px;
        margin-bottom: 100px;
        .from-content {
            display: flex;
            justify-content: center;
            align-items: center;
            .transition-icon {
                width: 64px;
                cursor: pointer;
                text-align: center;
                & > i {
                    font-size: 18px;
                }
                &[disabled] {
                    cursor: not-allowed;
                    pointer-events: none;
                    opacity: 0.5;
                }
            }
            .terminology-config {
                margin-left: 80px;
            }
        }
        .try-content {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            .left-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                max-width: 400px;
                min-width: 250px;
                min-height: 304px;
                background: #ffffff;
                border: 1px solid rgba(0, 0, 0, 0.1);
                box-sizing: border-box;
                border-radius: 8px;
                & > .input-content {
                    flex: 1;
                    position: relative;
                    .el-textarea {
                        height: 100%;
                    }
                    > .clear-btn {
                        position: absolute;
                        width: 30px;
                        height: 30px;
                        top: 0;
                        right: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                }
                & > .action-content {
                    display: flex;
                    justify-content: space-between;
                    margin: 20px;
                    font-size: 12px;
                    > .random-doc-btn {
                        text-align: left;
                        cursor: pointer;
                        color: $a-color;
                        &[disabled] {
                            opacity: 0.5;
                            pointer-events: none;
                            cursor: not-allowed;
                        }
                    }
                    > .tag-content {
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        color: #666;
                    }
                    > .word-number {
                        width: 50px;
                        text-align: right;
                    }
                }
            }
            .center-content {
                width: 430px;
                margin-left: 40px;
                margin-right: 40px;
                > .field-type-list {
                    display: flex;
                    border-bottom: 1px solid #0000000d;
                    > .item {
                        flex: 1;
                        font-size: 16px;
                        color: #00000066;
                        text-align: center;
                        margin-bottom: 20px;
                        cursor: pointer;
                        /* &:first-child{
                            text-align: left;
                        }
                        &:last-child{
                            text-align: right;
                        } */
                        &.active {
                            color: #000000;
                            font-weight: 500;
                        }
                    }
                }
                > .engine-list {
                    margin-top: 20px;
                    display: flex;
                    flex-wrap: wrap;
                    .item {
                        position: relative;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        width: 130px;
                        height: 44px;
                        background-color: #ffffff;
                        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
                        box-sizing: border-box;
                        border: 1px solid #ffffff;
                        border-radius: 6px;
                        // line-height: 44px;
                        margin-bottom: 20px;
                        &:nth-child(2),
                        &:nth-child(5),
                        &:nth-child(8),
                        &:nth-child(11),
                        &:nth-child(14),
                        &:nth-child(17),
                        &:nth-child(20),
                        &:nth-child(23),
                        &:nth-child(26),
                        &:nth-child(29),
                        &:nth-child(32),
                        &:nth-child(35),
                        &:nth-child(38),
                        &:nth-child(41),
                        &:nth-child(44),
                        &:nth-child(47),
                        &:nth-child(50),
                        &:nth-child(53),
                        &:nth-child(56),
                        &:nth-child(59) {
                            margin: 0 20px;
                        }
                        &.active {
                            border-color: #000000;
                            // color: #21B780;
                        }
                        &[disabled],
                        &:disabled {
                            cursor: not-allowed;
                            // pointer-events: none;
                            opacity: 0.5;
                        }
                        &.add-engine {
                            justify-content: center;
                            svg {
                                font-size: 20px;
                            }
                        }
                        > .engine-icon {
                            margin-left: 8px;
                            font-size: 22px;
                        }
                        > .engine-name {
                            font-size: 13px;
                            line-height: 24px;
                            flex: 1;
                            margin-left: 5px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        > .engine-more {
                            width: 20px;
                            height: 100%;
                            line-height: 44px;
                            text-align: center;
                            border-radius: 0 6px 6px 0;
                            &:hover {
                                background-color: #ededed;
                            }
                            svg {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
            .right-content {
                flex: 1;
                padding: 20px;
                max-width: 400px;
                min-width: 250px;
                min-height: 304px;
                max-height: 619px;
                overflow-y: auto;
                background-color: #ededed;
                border: 1px solid rgba(0, 0, 0, 0.1);
                box-sizing: border-box;
                border-radius: 8px;
                color: #000000;
                ::v-deep p {
                    line-height: 22px;
                    font-size: 14px;
                }
            }
        }
        > .advanced-setup-content {
            min-width: 957px;
            max-width: 1310px;
            margin: auto;
            margin-top: 20px;
            background-color: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.1);
            box-sizing: border-box;
            border-radius: 6px;
            > .title-content {
                display: flex;
                align-items: center;
                height: 50px;
                > .left {
                    width: 95px;
                    margin-left: 40px;
                    .title {
                        font-weight: 500;
                        font-size: 15px;
                        line-height: 21px;
                        color: #000000;
                        svg {
                            font-weight: 600;
                            margin-left: 6px;
                        }
                    }
                    .subtitle {
                        font-size: 12px;
                        line-height: 17px;
                        color: #00000066;
                        margin-top: 4px;
                    }
                }
                > .center {
                    flex: 1;
                    height: 100%;
                }
                > .right {
                    width: 60px;
                    height: 100%;
                    line-height: 70px;
                    text-align: center;
                    font-size: 20px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    svg {
                        transition: transform 0.2s linear;
                    }
                    &.show {
                        svg {
                            transform: rotateZ(135deg);
                        }
                    }
                }
            }
            .advanced-content {
                border-top: 1px solid #0000001a;
                margin: 0 40px 40px 40px;
            }
        }
    }
    .setting-content {
        width: 860px;
        margin: 0 auto;
        .project-info {
            ::v-deep .el-input__inner {
                border: none;
                font-size: 15px;
                font-weight: 600;
                color: #000000;
            }
        }
        .language-setting-content {
            background-color: #f8f8f8;
            border-radius: 6px;
            .target-select {
                ::v-deep .el-tag {
                    margin: 0 4px;
                    &.el-tag--info {
                        border-color: #f2f2f2;
                        background-color: #f2f2f2;
                        color: #000000;
                        font-size: 15px;
                    }
                }
                ::v-deep .el-tag--mini {
                    height: 26px;
                    line-height: 26px;
                }
            }
        }
        .language-list {
            padding: 0 20px 15px 20px;
            border-top: 1px solid #e6e6e6;
            box-sizing: border-box;
            margin-top: 15px;
            max-height: 240px;
            overflow-y: auto;
            .item {
                margin-top: 15px;
                display: flex;
                align-items: center;
                .compare-btn {
                    width: 32px;
                    height: 32px;
                    margin-left: 20px;
                    background-color: #fff;
                    border-radius: 50px;
                    border: 1px solid #0000001a;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    cursor: pointer;
                    &:hover {
                        border-color: #000000;
                    }
                    img {
                        width: 26px;
                    }
                }
                .engine-select {
                    width: 220px;
                    margin-left: 20px;
                    ::v-deep .el-input--prefix {
                        .el-input__inner {
                            padding-left: 45px;
                            font-weight: normal;
                        }
                    }
                    ::v-deep .el-input__prefix {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        left: 15px;
                    }
                }
            }
        }
        .tab-list {
            border-bottom: 1px solid #0000001a;
            height: 100%;
            display: flex;
            > .item {
                height: 100%;
                display: flex;
                padding-bottom: 15px;
                align-items: center;
                color: #00000066;
                font-size: 15px;
                box-sizing: border-box;
                margin-right: 40px;
                cursor: pointer;
                &.active {
                    color: #000000;
                    font-weight: 600;
                    border-bottom: 2px solid #000000;
                }
            }
        }
        .action-content {
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            // background-color: #f8f8f8;
        }
        ::v-deep .el-table .cell {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .qa-setting {
            .block-title {
                font-size: 14px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .option-list {
                display: flex;
                margin-bottom: 10px;
                flex-wrap: wrap;
                .item {
                    width: 25%;
                    padding: 12px 0;
                    word-break: break-all;
                    word-wrap: break-word;
                }
            }
        }
        .backup-engine-wapper {
            .group-name {
                font-size: 12px;
            }
            .engine-group {
                margin-top: 20px;
                margin-bottom: 20px;
                display: grid;
                grid-gap: 15px;
                grid-template-columns: repeat(auto-fill, minmax(119px, 1fr));
                .item {
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #f8f8f8;
                    border-radius: 4px;
                    box-sizing: border-box;
                    border: 1px solid transparent;
                    font-size: 18px;
                    cursor: pointer;
                    &.active {
                        border-color: #000000;
                        cursor: default;
                    }
                    .name {
                        font-size: 12px;
                        margin-left: 4px;
                    }
                }
            }
        }
        ::v-deep .el-input-number__decrease {
            background: rgb(248, 248, 248);
        }
        ::v-deep .el-input-number__increase {
            background: rgb(248, 248, 248);
        }
    }
    .remark-input {
        ::v-deep .el-textarea__inner {
            background-color: #f8f8f8;
            border: none;
            border-radius: 10px;
            padding: 10px 15px;
        }
    }
    .term-extract-list {
        margin-bottom: 40px;
        .tips {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            margin-bottom: 20px;
        }
        .retrans-tips {
            margin-top: 10px;
        }
        .el-button--text {
            color: $font-primary-color;
            &:hover,
            &foucs {
                color: $font-primary-color-hover;
            }
            &.delete-btn {
                color: $font-danger-color;
                &:hover,
                &foucs {
                    color: $font-danger-color-hover;
                }
            }
        }
    }
    .mem-matching-setting {
        ::v-deep .el-input__inner {
            border-radius: 50px;
        }
    }
}
.bold-form-label {
    ::v-deep .el-form-item__label {
        font-weight: bold;
        color: #000;
    }
}
</style>
